import {RaEvent, RaEventType} from "./RaEvent";

export enum RUNTIMETEST_STATUS {
    manual = 0,
    automatic = 1,
    connect = 2,
    disconnect = 3,
    success = 4
}

export class RuntimeTestEvent extends RaEvent {

    static TYPE:RaEventType = "runtimetest_event";

    constructor(private _status:RUNTIMETEST_STATUS) {
        super(RuntimeTestEvent.TYPE)
    }

    public get status():RUNTIMETEST_STATUS{
        return this._status;
    }
}
